// Save/restore window scroll across the auth-dialog detour so the
// "Back to home" link returns the user exactly where they were on the
// landing page.

const KEY = "auth_return_scroll";

export function saveScroll() {
  try {
    sessionStorage.setItem(
      KEY,
      JSON.stringify({ y: window.scrollY || 0, t: Date.now() })
    );
  } catch {
    // ignore
  }
}

export function popScroll() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    sessionStorage.removeItem(KEY);
    const { y } = JSON.parse(raw);
    return typeof y === "number" ? y : null;
  } catch {
    return null;
  }
}
